export enum IntegrationSystems {
  WordPress = 'WordPress',
}

export enum IntegrationErrors {
  INVALID_USER = 400,
  INVALID_PASSWORD = 401,
  INVALID_APPLICATION_PASSWORD = 403,
}
